'use strict';

/* jshint -W098 */
angular.module('mean.system-bids').controller('SystemBidsController', ['$scope', 'DocumentSevice', 'Global', 'MeanUser', 'Users', '$filter', 'Builders', 'Trades', 'toaster', 'bidQueryService', '$q', 'userService', 'builderService', 'TradeBids', 'tradeCodeService', '$uibModal', 'Projects', 'Materials', 'Equipments',
  function($scope, DocumentSevice, Global, MeanUser, Users, $filter, Builders, Trades, toaster, bidQueryService, $q, userService, builderService, TradeBids, tradeCodeService, $uibModal, Projects, Materials, Equipments) {
    $scope.global = Global;
    $scope.package = {
      name: 'system-bids'
    };

    console.log('in system-bids');

    $scope.user = MeanUser.user;
    $scope.bids = [];
    $scope.systemLots = [];
    $scope.display_bids = [];
    $scope.showExpandableDetails = -1;
    $scope.userMadeDateSelection = false;

    $scope.bidStructure = false;
    $scope.mainAccountId = null;
    $scope.isProgress = false;

    $scope.init = function() {
        Users.query({'type': 'SystemUsersOnly'}, function(users) {
          $scope.owner_list = users;
        });
    };

    $scope.changeOwner = function(o) {
        if(!o) return;
        $scope.isBuilder = false;
        if(builderService.isBuilder(o.username)) {
            $scope.isBuilder = true;
        }

        $scope.selectedBid = null;

        userService.getMainAccountId(o.username).then(function(result) {
            $scope.mainAccountId = result;
            if($scope.isBuilder) {
                Builders.query({'builder': $scope.selectedUser._id}, function(builders) {
                    bidQueryService.getNamesOnlyForBuilder(builders[0]._id).then(function(results) {
                        $scope.bid_list = results;
                    });
                });
            } else {
                Trades.query({'main_account_id': result}, function(trades) {
                    $scope.my_trade = trades[0];
                    bidQueryService.getNamesOnlyForTrade(trades[0]._id).then(function(results) {
                        $scope.bid_list = results;
                    });
                });
            }
        });
    };

    $scope.changeBid = function(b) {
        if(!b) return;

        bidQueryService.getById(b._id).then(function(result) {
            $scope.selectedBid = result[0];
            _.each($scope.selectedBid.bidding_trades, function(bid) {
                bid.trade_code = tradeCodeService.getCode(bid.trade);
            });
        });

        $scope.bidStructure = false;
        DocumentSevice.query({
            type: 'checkBidSetup',
            bidId: b._id,
            mainAccountId: $scope.mainAccountId
          }, function (result) {
              if (result.length) {
                $scope.bidStructure = true;
              } else {
                $scope.bidStructure = false;
              }
        });
    };

    $scope.syncBidSetup = function (b) {
        if(!b) return;
        $scope.isProgress = true;
        DocumentSevice.query({
            type: 'syncBidSetup',
            bidId: b._id,
            mainAccountId: $scope.mainAccountId
          }, function (result) {
            $scope.bidStructure = true;
            $scope.isProgress = false;
        }, function(error) {
            $scope.isProgress = false;
            toaster.pop('error', 'Error found', error.data.error)
        });
    }

    $scope.updateDates = function(item) {
        item.date_received = new Date(item.date_received);
        item.date_requested = new Date(item.date_requested);
        item.date_declined = new Date(item.date_declined);
        item.date_rejected = new Date(item.date_rejected);
        item.date_accepted = new Date(item.date_accepted);
        item.date_completed = new Date(item.date_completed);
    };

    $scope.editTradeData = function(item) {
        item.showTradeDetails = !item.showTradeDetails

        if(item.showTradeDetails) {
            TradeBids.query({'_id': item._id}, function(trades) {
                // $scope.tradeToEdit = trades[0];
                // $scope.updateDates($scope.tradeToEdit);
                // $scope.backuptrade = angular.copy(trades[0]);
                $scope.current_trade_bid = item = trades[0];
                $scope.updateDates(item);
                $scope.backuptrade = angular.copy(item);
            });
        } 
    };

    $scope.showModal = function(item) {
        //if(!item.showTradeDetails) {
            TradeBids.query({'_id': item._id}, function(trades) {
                // $scope.tradeToEdit = trades[0];
                // $scope.updateDates($scope.tradeToEdit);
                // $scope.backuptrade = angular.copy(trades[0]);
                item = trades[0];
                $scope.updateDates(item);
                $scope.backuptrade = angular.copy(item);

                var modalInstance = $uibModal.open({
                    templateUrl: 'system-bids/views/modals/edit-trade-data.html',
                    controller: 'ModalEditTradeController',
                    trade: item,
                    resolve: {
                        trade: function() {
                            return item;
                        },
                        selectedBid: function() {
                            return $scope.selectedBid;
                        }
                    }
                });

            });
        //}
    };

    $scope.showCostingModal = function(item) {
        TradeBids.query({'_id': item._id}, function(trades) {
            item = trades[0];
            $scope.updateDates(item);
            $scope.backuptrade = angular.copy(item);

            var modalInstance = $uibModal.open({
                templateUrl: 'system-bids/views/modals/edit-trade-costing.html',
                controller: 'ModalEditTradeCostingController',
                trade: item,
                resolve: {
                    trade: function() {
                        return item;
                    },
                    selectedBid: function() {
                        return $scope.selectedBid;
                    }
                }
            });

        });
    };

    // $scope.cancelTradeEdits = function() {
    //     var idx = $scope.selectedBid.bidding_trades.indexOf($scope.tradeToEdit);

    //     if(idx !== -1)
    //       $scope.selectedBid.bidding_trades[idx] = $scope.backuptrade;
    // };

    // $scope.acceptTradeEdits = function() {
    //     var idx = $scope.selectedBid.bidding_trades.indexOf($scope.tradeToEdit);
    //     $scope.tradeToEdit.$update(function(success) {
    //         $scope.updateDates(success);
    //         $scope.selectedBid.bidding_trades[idx] = success;

    //         toaster.pop('success', 'Trade Updated');
    //     }, function(error) {
    //         $scope.selectedBid.bidding_trades[idx] = $scope.backuptrade;
    //         toaster.pop('error', 'Trade DB Error', error);
    //     });
    // };

    $scope.setTradeToRemove = function(item) {
        TradeBids.query({'_id': item._id}, function(trades) {
            item = trades[0];
            $scope.updateDates(item);
            $scope.backuptrade = angular.copy(item);

            var modalInstance = $uibModal.open({
                templateUrl: 'system-bids/views/modals/remove-trade.html',
                controller: 'ModalRemoveTradeController',
                trade: item,
                resolve: {
                    trade: function() {
                        return item;
                    },
                    selectedBid: function() {
                        return $scope.selectedBid;
                    }
                }
            });
        });
    };

    $scope.showRefreshModal = function(item) {
        TradeBids.query({'_id': item._id}, function(trades) {
            item = trades[0];
            $scope.updateDates(item);
            $scope.backuptrade = angular.copy(item);

            var modalInstance = $uibModal.open({
                templateUrl: 'system-bids/views/modals/refresh.html',
                controller: 'ModalRefreshController',
                trade: item,
                resolve: {
                    trade: function() {
                        return item;
                    },
                    selectedBid: function() {
                        return $scope.selectedBid;
                    }
                }
            });

        });
    };

    $scope.changeProjectForBid = function() {
        console.log('changeProjectForBid');
        Projects.query({
              'company_code': $scope.selectedUser.contractor_code,
              'trade_code': tradeCodeService.getCode($scope.selectedUser.trade[0]),
              'type': 'NamesOnly',
              'complete': false,
              'username': $scope.selectedUser.username }
              , function(projects) {
            $scope.project_list = projects;
        });
    };

    $scope.acceptChangeProject = function(changeTo) {
        $scope.selectedBid.project_id = changeTo._id;

        $scope.selectedBid.$update(function(success) {
            $scope.selectedBid = success;
            toaster.pop('success', 'Bid Updated');
        }, function(error) {
            toaster.pop('error', 'Bid Update Error', error);
        });
    };


    $scope.changeMaterialSupplier = function() {
        if($scope.my_trade) {
            Materials.query({ 'trade_account': $scope.my_trade._id, 
                'get_suppliers': 1 }, function(items) {
                $scope.available_material_suppliers = items;
            });

            Equipments.query({ 'trade_account': $scope.my_trade._id, 
                'get_suppliers': 1 }, function(items) {
                $scope.available_equipment_suppliers = items;
            });
        }
    };

    $scope.acceptChangeMaterialAssociation = function() {
        $scope.current_trade_bid.$update(function(success) {
            $scope.current_trade_bid = success;
            toaster.pop('success', 'Bid Updated');
        }, function(error) {
            toaster.pop('error', 'Bid Update Error', error);
        });
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/system-bids/public/controllers/systemBids.js